import React, { Component, Fragment } from 'react';
import ReturnPageHeader from "pages/returnCheckout/ReturnPageHeader" 
import shop from "shop/shop"
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea, FormInput, Table} from "semantic-ui-react"
import queryString from "qs"
import ProductTable from "components/Product/ProductTableReturn"
import CartTotal from "components/Cart/CartTotal"
import Responsive from "react-responsive"
import { Link } from "react-router-dom"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import searchStore                 from "stores/searchStore"
import moment                               from "moment"
import ContactMessage from 'components/Messages/ContactMessage';
import LocalFooter from 'components/LocalFooter';
import _            from "lodash"
import categoryStore                                                                                 from "stores/categoryStore"
import cmsStore                                                                                      from "stores/cmsStore"
import productStore from "stores/productStore"
import ProductListItem from "components/Product/ProductListItem"
import ReturnPageProgress from './ReturnPageProgress';
import BarcodeScanner from "components/BarcodeScanner/BarcodeScannerJS"
 //ELEM REACT16 CHANGE
class ReturnPageQuantity extends Component {
    state = {
        products: [],
        frachtkosten: true,
        productsTemp: [],
        navHeader: false,
        searchString: "",
        barcodeData : "not found",
        newSeason: {
            season: {
                seasonActive: false,
                referenceNumber: "",
                email: "",
                start: "",
                end: "",
                name: ""
            }
        },
        productSearch: []
      }

      async componentDidMount() {
        //await shop.cart.hooks.changed.add( this.updateCart )
        await this.handleFetchDate()
        await this.load()
        await console.log("products",this.state.products, shop.cart.data)

        
      }
      
      handleChange = ( { product } ) => {
        //console.log("HANDLE CHANGE PRODUCT: ", product)
        shop.cart.add( product )
      }
      
      updateCart = () => {
        let products = getProducts()
        products = getProducts()
        this.setState( { products } )
        this.forceUpdate()
      }

      handleCheckForProductsInCart = async () => {
        let productInCart = false;
        await Promise.all(this.state.productSearch.map(async product => {
          if (shop.cart && shop.cart.data && shop.cart.data.positions) {
            productInCart = shop.cart.data.positions.find(position => position.article_id === product.map_id);
            if(productInCart !== false && productInCart !== undefined){
                product.count = productInCart.count
            }
          }
        }));
      }
      
      componentWillUnmount() {
        //this.setState({productsTemp: shop.cart.products})
        //shop.cart.hooks.changed.remove( this.updateCart )
      }

        async fetchCategoryPage( collectionId ) {
          try {
            let result = await shop.fetch( `/wp/wp-json/wp/v2/shop-category?slug=${collectionId}` )
            if ( result.length > 0 ) {
              this.setState( { categoryPage: result[ 0 ] } )
            } else {
              this.setState( { categoryPage: 0 } )
            }
          }
          catch (err) {
            console.error( "Error Fetching shop-category", err )
            this.setState( { categoryPage: 0 } )
          }
        }

        load = async ( props = this.props ) => {
          this.setState( { loading: true } )
          const query = queryString.parse( props.location.search.substr( 1 ) )
          const { categories = "" } = props.match.params
          const parentCategories = categories.split( "/" )
          const categoryId = "alleArtikel"
          const category = categoryStore.categoriesById.get( categoryId )
          console.log("CATEGORY",category, categoryId)
          // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS
          // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
          
          const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
          let filters = []
          const fields = _.pick( query, shop.config.pickFilter )
          const filterSize = _.size( fields )
          
          _.forEach( fields, ( value, key ) => {
            
            // MULTIFILTERS ARE ADDED AS "OR"
            if ( Array.isArray( value ) ) {
              let queryFilters = value.map( v => {
                return {
                  op: "equals", extra: true, field: key, value: v
                }
              } )
              
              let combinedFilter = { "or": queryFilters }
              filters.push( combinedFilter )
              
            } else {
              let filter = {
                op: "equals", extra: true, field: key, value: value
              }
              filters.push( filter )
            }
          } )
          
          // Only hide variants if we don't search by filter
          // i.e. user searches for color only available on variants
          if ( cmsStore.config.plugin.hideVariants ) {
            // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
            let noVariants = {
              op: "equals", field: "type", value: "1"
            }
            const singleItems = { "field": "mainArticle", "op": "equals", "value": "" } //CollectionPage mainArticle = mainart
            let combinedFilter = [{ "or": [singleItems, noVariants] }]
            filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
          }
          
          if ( categoryId ) {
            this.fetchCategoryPage( categoryId )
            productStore.fromCategory( categoryId, {
              value: "%%",
              dir: query.dir || shop.config.standards.DIR || "des",
              sort: query.sort || shop.config.standards.SORT || "sort",
              page,
              count: 250 || shop.config.standards.ITEMS_PER_PAGE,
            }, filters ).then( res => {
              if ( !res.products.length ) {
                
                console.log("NO PRODUCTS FOUND FOR CATEGORY ID:", categoryId)
                let catQuery = {
                  value: "%%",
                  dir: query.dir || shop.config.standards.DIR || "des",
                  sort: query.sort || shop.config.standards.SORT || "sort",
                  page,
                  count: count || shop.config.standards.ITEMS_PER_PAGE,
                }
                
                let additionalFilters = filters.filter( e => e.field !== "type" )
                
                // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
                return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                                   .then( res => {
                                    console.log("RES",res)
                                     let { products } = res
                                     if ( products.length === 0 ) {
                                       if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                         // get products from all child categories
                      
                                         const mapChildren = cat => {
                                           if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                           return cat.map_id
                                         }
                      
                                         const ids = _.flatten( category && category.children.map( mapChildren ) )
                                         if ( ids.length > 0 ) {
                                           return productStore.fromCategory( ids, catQuery, additionalFilters )
                                         }
                                       }
                                     }
                                     return res
                                   } )
              }
              this.setState({ loading: false, products: res.products, productSearch: res.products })
              this.handleCheckForProductsInCart()
              return res
            } )
                        .then( res => {
                          let { products, meta = {}, fields, size } = res
                          fields = fields || meta.fields
                         // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                          this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                          return res
                        } )
          } else {
            productStore.query( {
                                  value: "%%",
                                  filter: [...filters],
                                  dir: query.dir || shop.config.filter_defaults.sort || "des",
                                  sort: query.sort || shop.config.filter_defaults.sort,
                                  page,
                                  count: count || shop.config.standards.ITEMS_PER_PAGE,
                                } )
                        .then( res => {
                          lastFilter = this.props.location.search
                          let { products, size } = res
                          this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                        } )
          }
        }

      handleFetchDate  = () => {
        this.setState({loading: true})
        console.log("DATA handleFetchDate")
        try {
          const response = shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.saison","web.kv.start","web.kv.end"])), {
            method: 'GET',
            credentials: 'include'
          });
          //console.log("DATA: ", response, this.state.newSeason);

          response.then(data => {
            //console.log("DATA RETURN: ", data["web.kv.end"]);
            this.setState({
              newSeason: {
                season: {
            start: data["web.kv.start"],
            end: data["web.kv.end"],
            name: decodeURIComponent(data["web.kv.saison"])
                }
              }
            });
            //console.log("DATA POST: ", data);
            const today = new Date();
            const startDate = moment(data["web.kv.start"], "DD.MM.YYYY").toDate();
            const endDate = moment(data["web.kv.end"], "DD.MM.YYYY").toDate();
            //console.log("DATA DATE: ", today, startDate, endDate);
            if (today >= startDate && today <= endDate) {
              this.setState({ seasonActive: true });
              //console.log("DATA ACTIVE: ", this.state.newSeason);
            }
            this.setState({loading: false})
          })

        } catch (error) {
          console.error('Error fetching date:', error);
        }
      }

    render() {
        const { referer = "/", ...query } = queryString.parse( location.search, { ignoreQueryPrefix: true } )
        let { products, productSearch } = this.state


        //console.log("SHOP RETURN: ", shop.return)
        const handleChangeSearchString = (event) => {
            //console.log("SEARCH CHANGE: ", event.target, this.state.products)
            this.setState({productSearch: []})
            for(let i = 0; i < this.state.products.length; i++){
              //console.log("PRODUCT CHECK: ", this.state.products[i], event.target.value.toUpperCase(), this.state.products[i].cats[1].cat_id.toUpperCase(),  this.state.products[i].cats[1] && this.state.products[i].cats[1].cat_id && this.state.products[i].cats[1].cat_id.toUpperCase().includes(event.target.value.toUpperCase()))
                if(this.state.products[i].article_nr.includes(event.target.value) || 
                    this.state.products[i].desc.short_des.toUpperCase().includes(event.target.value.toUpperCase()) || 
                    this.state.products[i].barcode.includes(event.target.value) ||
                    (this.state.products[i].cats[0] && this.state.products[i].cats[0].cat_id && this.state.products[i].cats[0].cat_id.toUpperCase().includes(event.target.value.toUpperCase())) ||
                    (this.state.products[i].cats[1] && this.state.products[i].cats[1].cat_id && this.state.products[i].cats[1].cat_id.toUpperCase().includes(event.target.value.toUpperCase())) ||
                    (this.state.products[i].extras && this.state.products[i].extras.category && this.state.products[i].extras.category.toUpperCase().includes(event.target.value.toUpperCase())) ||
                    (shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" &&
                        this.state.products[i].extras && this.state.products[i].extras.rewe_nan && this.state.products[i].extras.rewe_nan.value.value.toUpperCase().includes(event.target.value.toUpperCase())) ||

                      (shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" &&
                        this.state.products[i].extras && this.state.products[i].extras.edeka_nan && this.state.products[i].extras.edeka_nan.value.value.toUpperCase().includes(event.target.value.toUpperCase()))) {
                    this.setState(prevState => ({
                        productSearch: [...prevState.productSearch, this.state.products[i]]
                    }));
                    //console.log("RETURN SEARCH CHANGE CORRECT", this.state.products[i])
                }
            }
            this.setState({searchString: event.target.value})
          }; 
        const handleClearSearchString = () => {
            this.setState({productSearch: products, searchString: ""});
        }
    
        const handleCommentChange = ( event ) => {
        console.log("VALUE:",event.target)
        let comment = event.target.value
        this.setState(prevState => {
            let newcust = { ...prevState.newcust };  
            newcust.contact.comment = comment;       
            return { newcust }; 
            })
        }

        const handlebarcodeDataChange = ( barcode ) => {
          this.setState({ barcodeData: barcode })
          this.setState({ searchString: barcode })
          const event = { target: { value: barcode } };
          handleChangeSearchString(event);
        }

        //console.log("products QuanPage",products)
        /*for (let i = 0; i < shop.delivery[0].positions.length; i++) {
            for(let j = 0; j < shop.cart.length; j++){
                console.log("products",products[j].article_nr," shop.delivery.positions", shop.delivery[0].positions[i].article_id)
                if(shop.delivery[0].positions[i].article_id === products[j].article_nr){
                    console.log("products",products[j].article_nr)
                    products[j].deliveryCount = shop.delivery[0].positions[i].count
                    products[j].trueReturnValue = products[j].trueReturnValue || false
                }
            }
        }*/
        
        return (
            <Fragment>
                <section className="container pt2 pb2">
                    <ReturnPageProgress progress={1} />
                </section>
            <Responsive minWidth={790} >
            <div>
            <Table style={{border: "none"}}>
            <colgroup>
                <col width="10%" />
                <col width="12%" />
                <col width="3%" />
                <col width="55%" />
            </colgroup>
            <tbody>
                <tr>
                <td>
                    &nbsp;
                </td>
                <td className="pr4  pl4 v-top ReturnPageAlignment" >
                    <ReturnPageHeader className="v-top" activeStep={0} />
                </td>
                <td>
                    &nbsp;
                </td>
                <td className="pr4  pl4 v-top ReturnPageAlignment" >
                    <h1 style={{color:"#917236", fontSize:40}}  className="pt5 tl"><b>Restanten erfassen</b></h1>
                    <Message style={{width: "80%"}} >
                    <ContactMessage />
                            </Message>
                    <Message style={{width: "80%"}}>
                    <div>{translate( `Bitte tragen Sie den aktuellen Restbestand der Lindt Saison ${this.state.newSeason.season.name} in die untenstehende Erfassungsmaske bis zum `)}<span className="b" style={{color:"red"}}>{this.state.newSeason.season.end || "01.01.2025"}</span>{translate(" ein.")}</div>
                    </Message>
                    <Message className="ui negative message" style={{width: "80%"}}>
                    <div><Icon className="warning circle"></Icon>
                    {translate( "Unkorrekte Angaben werden von LINDT & SPRÜNGLI nicht vergütet. Die Angaben der Restanten müssen Artikel-Genau erfolgen.")}</div>
                    </Message>
                    <br/>
                    <div className="pb3 bb b--black-10 " style={{width: "80%"}}>
                      <table>
                        <colgroup>
                          <col width="50%" />
                          <col width="50%" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                            <div className=" fw7" style={{color:"#917236", fontSize:20}}>Barcode Scanner</div>
                            </td>
                            <td>
                            {shop.session && shop.session.value && shop.session.value.extras && <div className=" fw7" style={{color:"#917236", fontSize:20}} >Zählunterstützung  </div>}
                            </td>
                          </tr>
                          <tr>
                            <td>
                            <BarcodeScanner barcodeData={this.state.barcodeData} productSearch={this.state.productSearch.length > 0 && this.state.productSearch.length < 2 ? this.state.productSearch : []} setBarcodeData={(barcode) => handlebarcodeDataChange(barcode)} />
                            </td>
                            <td>
                            {shop.session && shop.session.value && shop.session.value.extras && 
                        <Button primary onClick={() => {window.open(`${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "/Restantenschein Ostern 2026 - digital.pdf"
                        : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "/EDEKA Legende_Restantenschein Ostern 2026.pdf" :  "/Restantenschein Ostern 2026 - digital.pdf"}`, "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                              </td>
                          </tr>
                          {/*                          <tr>
                            <td>
                              <p className="pt2 black-30">Die entwickelte Funktion „Barcode Scanner“ befindet sich derzeit in der Beta-Phase und wird noch getestet. Es kann daher zu Einschränkungen in der Funktionalität kommen.</p>
                            </td>
                            <td>
                              &nbsp;
                              </td>
                            </tr> */}
                        </tbody>
                      </table>
                    </div>
                    <div className="pb2 pt3 fw7" style={{color:"#917236", fontSize:20}}>Produktsuche</div>
                    <div className="headerInline">
                    <FormInput
                    Icon="search"
                    style={{ minWidth: "500px" }}
                    className={""}
                    value={this.state.searchString}
                    onChange={handleChangeSearchString} icon="search" placeholder={translate( `Suche nach Artikelnummer, ${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "Rewe NAN," 
                    : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "Edeka Art-Nr.," : ""} EAN oder Beschreibung` ) + " ..."}>
                    </FormInput>
                    <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                    <Icon name="close"></Icon>
                    </Button>
                    </div>
                    {/*                    <div className="pb2 pt3" style={{color:"#917236", fontSize:20}}>Barcode Scanner beta*</div>
                    <div className="pb3 bb b--black-10" style={{width: "80%"}}>
                    <div className="headerInline">
                    <section><BarcodeScanner barcodeData={this.state.barcodeData} productSearch={this.state.productSearch.length > 0 && this.state.productSearch.length < 2 ? this.state.productSearch : []} setBarcodeData={(barcode) => handlebarcodeDataChange(barcode)} /></section>
                      
                    </div>
                    </div> */}
                    <div className="pb2 pt3 fw7" style={{color:"#917236", fontSize:20}}>Kategorie</div>
                    <div className="pb3">
                        <table className="w-80">
                            <colgroup>
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <tbody>
                            <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "Saison" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "Saison" }, () => {
                                            const event = { target: { value: "Saison" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >Gesamt Saison</Button>
                                </td>
                                <td className={this.state.searchString === "HELLO" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "HELLO" }, () => {
                                            const event = { target: { value: "HELLO" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >HELLO</Button>
                                </td>
                                <td className={this.state.searchString === "C+C Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "C+C Ware" }, () => {
                                            const event = { target: { value: "C+C Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >C+C Ware</Button>
                                </td>
                                <td className={this.state.searchString === "lose Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "150px"}} primary onClick={() => { 
                                        this.setState({ searchString: "lose Ware" }, () => {
                                            const event = { target: { value: "lose Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >lose Ware</Button>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="pb3 pt3">
                    {/*<OrderDetailTable products={shop.delivery[0].positions} />*/}
                    {/*<ProductTable cart={shop.cart} onChange={this.handleChange} products={productSearch}/>*/}

                    </div>
                    <div className="w-80 pt3 pb3">
                    {productSearch.map( ( product, index ) => <ProductListItem
                                      index={index}
                                      key={product.map_id}
                                      product={product}
                                      /> )}
                    </div>
                </td>
                </tr>
                <tr>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td className="tr divAlignRight">
                <strong style={{color:"#917236", fontSize:16}} >Restantenmenge: </strong>&nbsp;<CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
                </td>
                </tr>
                <tr>
                <td>
                &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    &nbsp;
                </td>
                <td>
                    <div style={{paddingTop: "50px",width: "80%"}} className="">
                    <Link to={{
                    pathname: `/return`,
                    search  : this.props.location.search
                    }}>
                    <Button
                    primary >
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                    </Button>
                    </Link>
                    <Button
                        className="fr"
                        disabled={false}
                        primary
                        onClick={() => {this.props.history.push("/return/contactPerson")}}
                        >{translate( "Restanten bestätigen" )}</Button>
                    </div>
                </td>
                </tr>
                </tbody>
            </Table>
            </div>
            </Responsive>    
            <Responsive maxWidth={789} >
            <table>
            <colgroup>
                <col width="90%" />
            </colgroup>
            <tbody>
                <tr className="bb b--black-10">
                <td>
                <div className="headerInline"><Button style={{backgroundColor: "#ffffff", maxWidth:"55px"}} 
                    onClick={() => (this.state.navHeader ? this.setState({navHeader : false}) : this.setState({navHeader : true}
                    ))}>
                    <Icon className="big bars tc" ></Icon>
                    </Button><span className="pt3 tc fw7 f2">Restanten</span> 
                    </div>
                {this.state.navHeader && <ReturnPageHeader className="v-top" activeStep={0} />}
                </td>
                </tr>
                <tr className="tc">
                <td className="tc pr2  pl2 v-top ReturnPageAlignment" >
                {/*<td className="pr4  pl4 v-top ReturnPageAlignment" >
                    
                </td>*/}
                    <h1 style={{color:"#917236", fontSize:40}}  className="tc"><b>Restanten erfassen</b></h1>
                    <Message >
                    <ContactMessage />
                            </Message>
                    <Message >
                    <div>{translate( `Bitte tragen Sie den aktuellen Restbestand der Lindt Saison ${this.state.newSeason.season.name} in die untenstehende Erfassungsmaske bis zum `)}<span className="b" style={{color:"red"}}>{this.state.newSeason.season.end || "01.01.2025"}</span>{translate(" ein.")}</div>
                    </Message>
                    <br/>
                    <div className="pb2 pt3 fw6" style={{color:"#917236", fontSize:20}}>Produktsuche</div>
                    <div className="headerInline tc pl3 pr3 w-100">
                    <FormInput
                    Icon="search"
                    style={{ width: "100%"}}
                    className={"tc"}
                    value={this.state.searchString}
                    onChange={handleChangeSearchString} icon="search" placeholder={translate( `Suche nach Artikelnummer, ${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "Rewe NAN," 
                    : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "Edeka Art-Nr.," : ""} EAN oder Beschreibung` ) + " ..."}>
                    </FormInput>
                    <Button onClick={handleClearSearchString} style={{backgroundColor: "#ffffff", maxWidth:"55px"}} >
                    <Icon name="close"></Icon>
                    </Button>
                    </div>
                    <div className="pb3 bb b--black-10 " >
                      <table>
                        <colgroup>
                          <col width="50%" />
                          <col width="50%" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <td>
                            <div className=" fw7" style={{color:"#917236", fontSize:20}}>Barcode Scanner</div>
                            </td>
                            <td>
                            {shop.session && shop.session.value && shop.session.value.extras &&  <div className=" fw7" style={{color:"#917236", fontSize:20}} >Zählunterstützung  </div>}
                            </td>
                          </tr>
                          <tr>
                            <td>
                            <BarcodeScanner barcodeData={this.state.barcodeData} productSearch={this.state.productSearch.length > 0 && this.state.productSearch.length < 2 ? this.state.productSearch : []} setBarcodeData={(barcode) => handlebarcodeDataChange(barcode)} />
                            </td>
                            <td>
                            {shop.session && shop.session.value && shop.session.value.extras && (!shop.session.value.extras.rewe_extra || !shop.session.value.extras.edeka_extra) &&
                        <Button primary onClick={() => {window.open(`${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "/Restantenschein Ostern 2026 - digital.pdf"
                        : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "/EDEKA Legende_Restantenschein Ostern 2026.pdf" :  "/Restantenschein Ostern 2026 - digital.pdf"}`, "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                              </td>
                          </tr>
                          {/*<tr>
                            <td>
                              <p className="pt2 black-30">Die entwickelte Funktion „Barcode Scanner“ befindet sich derzeit in der Beta-Phase und wird noch getestet. Es kann daher zu Einschränkungen in der Funktionalität kommen.</p>
                            </td>
                            <td>
                              &nbsp;
                              </td>
                            </tr>*/}
                        </tbody>
                      </table>
                    </div>
                    
                    <div className="pb2 pt3" style={{color:"#917236", fontSize:20}}>Kategorie</div>
                    <div className="pb3">
                        <table className="w-80">
                            <colgroup>
                            <   col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    &nbsp;
                                </tr>
                            <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "Saison" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "Saison" }, () => {
                                            const event = { target: { value: "Saison" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >Gesamt Saison </Button>
                                </td>
                                <td className={this.state.searchString === "HELLO" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "HELLO" }, () => {
                                            const event = { target: { value: "HELLO" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >HELLO</Button>
                                </td>
                                </tr>
                                <tr className="tc pl2 pr2">
                                <td className={this.state.searchString === "C+C Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "C+C Ware" }, () => {
                                            const event = { target: { value: "C+C Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >C+C Ware</Button>
                                </td>
                                <td className={this.state.searchString === "lose Ware" ? "selectedCategory pl2 pr2 tc" : "tc pl2 pr2"}>
                                    <Button style={{minWidth: "170px"}} primary onClick={() => { 
                                        this.setState({ searchString: "lose Ware" }, () => {
                                            const event = { target: { value: "lose Ware" } };
                                            handleChangeSearchString(event);
                                        });
                                    }} >lose Ware</Button>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="pb3 pt2">
                    {/*<OrderDetailTable products={shop.delivery[0].positions} />*/}
                    {/*<ProductTable cart={shop.cart} onChange={this.handleChange} products={productSearch}/>*/}
                    </div>
                    <div className="pt3 pb3">
                    {productSearch.map( ( product, index ) => <ProductListItem
                                      index={index}
                                      key={product.map_id}
                                      product={product}
                                      /> )}
                    </div>
                    <div className="tr pt2 pr3">
                    <strong style={{color:"#917236", fontSize:18}} >Restantenmenge: </strong>&nbsp;<CartTotal sum={shop.cart.sum} size={shop.cart.size}/>
                    </div>
                    <div className="pt3">
                    <div className="tl">
                    <Link to={{
                    pathname: `/return`,
                    search  : this.props.location.search
                    }}>
                    <Button
                    primary >
                    {translate( "Zurück" )}
                    <i className="icon-angle-right"/>
                    </Button>
                    </Link>
                    <Button
                        className="fr"
                        disabled={false}
                        primary
                        onClick={() => {this.props.history.push("/return/contactPerson")}}
                        >{translate( "Restanten bestätigen" )}</Button>
                    </div>
                    </div>
                </td>
                </tr>
                </tbody>
            </table>
            </Responsive>
            <LocalFooter/>
            </Fragment>
        );
    }
}

let lastFilter = false

const getProducts = () => shop.cart.map( ( product ) => product)

export default ReturnPageQuantity;


// WEBPACK FOOTER //
// ./src/theme/lindt/pages/returnCheckout/ReturnPageQuantity.js